import {HeaderController} from './header-controller'
import {LeftPanelController} from './left-panel-controller'
import {LeftSlidebarController} from './left-slidebar-controller'
import {ReceivedMailController} from './received-mail-controller'

angular.module("app").controller("HeaderController", ["$scope", "$rootScope", HeaderController]);
angular.module("app").controller("LeftPanelController", ["$scope", "$rootScope", LeftPanelController]);
angular.module("app").controller("LeftSlidebarController", ["$scope", "$rootScope", LeftSlidebarController]);
angular.module("app").controller("ReceivedMailController", ["$rootScope", "$scope", "$interval", "$timeout", "$sce", "socket", "UserService", "LikeService", "LockService", "ChatService", "toastr", ReceivedMailController]);
